import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// THE SOCIAL LAYER (2026-10-24, the Mark) - the same friends panel Terror, the Pier and Hooked carry
// (IEFriends.js, vendored byte-identical from gamemaster/engine). Renders nothing until you're signed in.
import IESocialDock from "./IEFriends";
import Mark from "./Mark";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
    <IESocialDock game="moonshine" accent="#e8a84a" MarkView={Mark} />
  </React.StrictMode>
);
